import { Toast } from "vant";

export function showLoading() {
  Toast.loading({
    message: "加载中...",
    duration: 0,
    forbidClick: true,
  });
}

export function hiddenLoading() {
  Toast.clear();
}
